import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";

import { CrossIcon, DeleteIcon } from "../../assets/Icon/ModalIcon";
import { useState } from "react";
import { useAppDispatch } from "../../stores/store";
import { setToast } from "../../stores/toast/toastslice";
import { getErrorMessage } from "../../utils/functions";
import {
  ButtonWrapper,
  CloseButton,
  CloseButtonWrapper,
  Content,
  Header,
  ModalWrapper,
} from "../../components/style/modalStyleLarge";
import { Divider, Box, useTheme, useMediaQuery } from "@mui/material";
import CustomButton from "../../components/common-components/CustomButton";
import deleteImg from "../../assets/Images/delete-img.png";
import { deleteClient, getClientList } from "../../stores/clients";

interface ModalPropType {
  open: boolean;
  handleClose: () => void;
  id: number | null;
  onSuccess?: () => void;
}

export default function DeleteModal({
  open,
  handleClose,
  id,
  onSuccess,
}: ModalPropType) {
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  
  const handleDelete = async () => {
    if (id === null) {
      dispatch<any>(setToast({ type: "error", message: "Invalid ID!" }));
      return;
    }

    setLoading(true);

    try {
      const response = await dispatch<any>(deleteClient(id)).unwrap();
      if (response?.status === 1) {
        dispatch<any>(setToast({ type: "success", message: response?.message }));
        if (onSuccess) {
          onSuccess();
        }
        handleClose();
      } else {
        dispatch<any>(setToast({ type: "error", message: "Failed to delete!" }));
      }
    } catch (error) {
      dispatch<any>(setToast({ type: "error", message: getErrorMessage(error) }));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="delete-modal-title"
      sx={{ zIndex: 99 }}
    >
      <ModalWrapper
        sx={{
          width: isMobile ? "90%" : "45%",
          maxWidth: "498px",
          minHeight: "350px",
          maxHeight: "602px",
          margin: "auto",
          overflow: "hidden",


          p: isMobile ? 2 : 3,
        }}
      >
        <CloseButtonWrapper>
          <CloseButton onClick={handleClose}>
            <CrossIcon />
          </CloseButton>
        </CloseButtonWrapper>

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            // margin: "20px 0",
          }}
        >
          <DeleteIcon />
        </Box>

        <Content sx={{ textAlign: "center" }}>
          <Typography
            sx={{
              fontSize: "22px",
              fontWeight: 700,
              marginBottom: "12px",
            }}
          >
            Delete Client
          </Typography>
          <Typography
            sx={{
              fontSize: "16px",
              textAlign: "center",
              marginBottom: "20px",
              lineHeight: "1.5",
              color: "#6C6F71",
            }}
          >
            Are you sure you want to delete the client?
          </Typography>
        </Content>

        <ButtonWrapper
          sx={{
            display: "flex",
            marginTop: "15px",
            marginBottom: "15px",
            justifyContent: isMobile ? "center" : "space-between",
            flexDirection: isMobile ? "column" : "row",
            gap: isMobile ? "10px" : "2px",
          }}
        >
          <CustomButton
            btnTitle="No"
            handleClick={handleClose}
            disabled={loading}
            minwidth={isMobile ? "100%" : "45%"}
            bgColor="#FFF"
            textColor="#2977CC"
            borderColor={loading ? "transparent" : "#2977CC"}
            borderWidth={2.3}
            sx={{ fontSize: "18px" }}
          />

          <CustomButton
            btnTitle={"Yes"}
            loading={loading}
            handleClick={handleDelete}
            disabled={loading}
            minwidth={isMobile ? "100%" : "45%"}
            borderColor={loading ? "transparent" : "#2977CC"}
            sx={{ fontSize: "18px" }}
          />
        </ButtonWrapper>
      </ModalWrapper>
    </Modal>
  );
}
